export interface OptionItem {
  id: string | number;
  label: string;
  disabled?: boolean | null;
  tooltipContent?: string;
}
